/* Group the existing phone controls without replacing their listeners or saved state. */
(() => {
  'use strict';
  const mobile = matchMedia('(max-width: 749px)');
  const wide = matchMedia('(min-width: 1800px)');
  const homes = new Map();
  let host, dialog, toggle, panel;
  function close(returnFocus = true) {
    if (!dialog?.open) return;
    dialog.close();
    toggle.setAttribute('aria-expanded', 'false');
    if (returnFocus && !host.hidden) {
      const drawer = toggle.closest('[data-avalon-drawer]');
      const target = drawer && drawer.getAttribute('data-open') !== 'true' ? document.querySelector('[data-avalon-drawer-toggle]') : toggle;
      target?.focus({preventScroll:true});
    }
  }
  function init() {
    if (!host) {
      if (document.querySelector('.avalon-atmosphere')) return;
      dialog = document.createElement('dialog');
      if (typeof dialog.showModal !== 'function') return; // Original controls remain usable.
      host = document.createElement('div'); host.className = 'avalon-atmosphere';
      toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'avalon-atmosphere__toggle';
      toggle.innerHTML = '<span aria-hidden="true">✧</span> Atmosphere';
      toggle.setAttribute('aria-haspopup','dialog'); toggle.setAttribute('aria-controls','AvalonAtmosphere'); toggle.setAttribute('aria-expanded','false');
      dialog.id = 'AvalonAtmosphere'; dialog.className = 'avalon-atmosphere__dialog'; dialog.setAttribute('aria-labelledby','AvalonAtmosphereTitle'); dialog.setAttribute('role','dialog'); // Armory's interaction guard recognizes this explicit role.
      dialog.innerHTML = '<div class="avalon-atmosphere__heading"><h2 id="AvalonAtmosphereTitle">Make yourself at home</h2><button type="button" class="avalon-atmosphere__close" aria-label="Close atmosphere">×</button></div><p class="avalon-atmosphere__intro">Set the mood for your visit.</p><div class="avalon-atmosphere__controls"></div>';
      panel = dialog.querySelector('.avalon-atmosphere__controls');
      toggle.addEventListener('click', () => { const drawer = toggle.closest('[data-avalon-drawer]'); if (drawer?.getAttribute('data-open') === 'true') drawer.querySelector('[data-avalon-drawer-close]')?.click(); dialog.showModal(); toggle.setAttribute('aria-expanded','true'); });
      dialog.querySelector('.avalon-atmosphere__close').addEventListener('click', () => close());
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('close', () => toggle.setAttribute('aria-expanded','false'));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
      host.append(toggle,dialog); document.body.append(host);
    }
    close(false);
    const slot = mobile.matches ? null : document.querySelector(wide.matches ? '[data-avalon-atmosphere-wide-slot]' : '[data-avalon-atmosphere-slot]');
    if (slot) slot.append(toggle); else if (toggle.parentElement !== host) host.prepend(toggle);
    document.body.classList.toggle('avalon-atmosphere-in-menu', !!slot);
    if (slot || mobile.matches) {
      document.querySelectorAll('.avalon-sound,.avalon-night-controls,.avalon-armory').forEach(control => {
        if (panel.contains(control)) return;
        if (!homes.has(control)) { const marker=document.createComment('Avalon control home'); control.before(marker); homes.set(control,marker); }
        panel.append(control);
      });
      host.hidden = !panel.children.length;
      document.body.classList.toggle('avalon-atmosphere-mobile',!slot && !host.hidden);
    } else {
      homes.forEach((marker,control) => { if (control.isConnected && marker.isConnected) marker.after(control); });
      host.hidden = true;
      document.body.classList.remove('avalon-atmosphere-mobile');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  mobile.addEventListener('change',init);
  wide.addEventListener('change',init);
  document.addEventListener('avalon:navigated',init);
  document.addEventListener('avalon:before-navigate',() => close(false));
  document.addEventListener('shopify:section:load',init);
})();
